import type { RouteObject } from "react-router-dom";

export const loginPath = "/login";

export const loginRoute: RouteObject = {
    path: loginPath,
    lazy: async () => {
        const { LoginPage } = await import("@/features/login/page");
        return { Component: LoginPage };
    },
};
